import * as unterrichtPage from "./auswertungen-unterricht";
import * as praktikumPage from "./auswertungen-praktikum";
import * as wuenschePage from "./auswertungen-wuensche";

/**
 * Sammelpunkt fuer Auswertungen ueber die Module hinweg.
 *
 * Die Reiter haengen an unterschiedlichen Modulen: die Unterrichtsauswertung am
 * Stundenplan, der Praktikumsfortschritt an der Planung, die Wuensche pro
 * Praktikumsstelle am Schueler-Portal (nur dort entstehen Wuensche). Eine Schule hat
 * oft nicht alles, deshalb zeigt der Hub nur die Reiter, die freigeschaltet sind,
 * und laesst die Leiste bei einem einzigen Reiter ganz weg.
 *
 * Der aktive Reiter steht im URL-Query (#/auswertungen?bereich=...), damit
 * Deep-Links und der Zurueck-Button funktionieren. Aufbau wie in
 * settings-stundenplan-hub.ts.
 */
type Tab = { id: string; label: string; feature: string; render: (el: HTMLElement) => Promise<void> };

const TABS: Tab[] = [
  { id: "unterricht", label: "Unterricht", feature: "stundenplan", render: unterrichtPage.render },
  { id: "praktikum", label: "Praktikum", feature: "planung", render: praktikumPage.render },
  { id: "wuensche", label: "Wünsche", feature: "schuelerPortal", render: wuenschePage.render },
];

let userFeatures: string[] = [];

export function setUserContext(features: string[]): void {
  userFeatures = features;
}

function visibleTabs(): Tab[] {
  return TABS.filter(t => userFeatures.includes(t.feature));
}

function activeTab(tabs: Tab[]): string {
  const query = window.location.hash.split("?")[1] || "";
  const bereich = new URLSearchParams(query).get("bereich");
  return tabs.some(t => t.id === bereich) ? bereich! : tabs[0].id;
}

export async function render(el: HTMLElement): Promise<void> {
  const tabs = visibleTabs();
  if (tabs.length === 0) {
    el.innerHTML = `<div class="empty-state"><p>Für Auswertungen wird die Planung, der Stundenplan oder das Schüler-Portal benötigt.</p></div>`;
    return;
  }

  // Ein einzelner Reiter braucht keine Reiterleiste.
  if (tabs.length === 1) {
    await tabs[0].render(el);
    return;
  }

  el.innerHTML = `
    <div class="detail-tabs">
      ${tabs.map(t => `<button class="detail-tab" data-tab="${t.id}">${t.label}</button>`).join("")}
    </div>
    <div id="aw-tab-content"></div>`;

  const content = el.querySelector<HTMLElement>("#aw-tab-content")!;

  const renderActive = async () => {
    const current = activeTab(tabs);
    el.querySelectorAll<HTMLButtonElement>(".detail-tab").forEach(b =>
      b.classList.toggle("active", b.dataset.tab === current));
    content.innerHTML = `<div style="display:flex;align-items:center;justify-content:center;height:200px"><div class="spinner"></div></div>`;
    await tabs.find(t => t.id === current)!.render(content);
  };

  el.querySelectorAll<HTMLButtonElement>(".detail-tab").forEach(btn => {
    btn.addEventListener("click", () => {
      // pushState loest kein hashchange aus, deshalb rendern wir selbst; beim
      // Zurueckgehen uebernimmt der Router in app.ts.
      history.pushState(null, "", `#/auswertungen?bereich=${btn.dataset.tab}`);
      void renderActive();
    });
  });

  await renderActive();
}
